import useStyles from "./style";

const DAYS = [
  { label: "Lun", value: 1 },
  { label: "Mar", value: 2 },
  { label: "Mer", value: 3 },
  { label: "Jeu", value: 4 },
  { label: "Ven", value: 5 },
  { label: "Sam", value: 6 },
  { label: "Dim", value: 7 },
];

interface DaysCheckBoxGroupProps {
  value: number[];
  onChange: (value: number[]) => void;
}

export default function DaysCheckBoxGroup({
  value = [],
  onChange,
}: DaysCheckBoxGroupProps) {
  const classes = useStyles();

  const toggleDay = (dayValue: number) => {
    if (!onChange) return;
    if (value.includes(dayValue)) {
      onChange(value.filter((v) => v !== dayValue));
    } else {
      onChange([...value, dayValue]);
    }
  };

  return (
    <div style={{ display: "flex", flexWrap: "wrap" }}>
      {DAYS.map((day) => (
        <div
          key={day.value}
          className={`${classes.dayBox} ${
            value.includes(day.value) ? "selected" : ""
          }`}
          onClick={() => toggleDay(day.value)}
        >
          {day.label}
        </div>
      ))}
    </div>
  );
}
